export default __webpack_public_path__ + "static/media/CNo.87-7.98500b1f.jpg";